import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Joyride, { Step } from 'react-joyride';
import { useTheme } from 'styled-components';

interface UserGuidProps {
    steps: Step[];
    showUserGuid: boolean | undefined;
    onHide: () => void;
}

const UserGuid: FC<UserGuidProps> = ({ steps, showUserGuid, onHide }) => {
    const { t } = useTranslation();
    const { colors, typography } = useTheme();
    const [isDisplayNone, setIsDisplayNone] = useState(false);

    const [locale] = useState({
        back: t('back'),
        close: t('close'),
        last: t('got_it'),
        next: t('next'),
        skip: t('skip'),
    });

    const handleJoyrideCallback = (data: any) => {
        if (data.index === 4) {
            setIsDisplayNone(true);
        }
        if (data.action === 'reset') {
            onHide();
        }
    };

    const customStyles = {
        tooltip: {
            borderRadius: 4,
            color: colors.text.secondaryReverse,
            fontSize: typography.size.desktop.paragraph.p3,
            padding: 10,
        },
        tooltipContainer: {
            textAlign: 'left' as const,
            lineHeight: `calc(${typography.lineHeight[2]} - 1px)`,
        },
        tooltipContent: {
            padding: 0,
        },
        tooltipFooter: {
            marginTop: 8,
            justifyContent: 'space-between',
        },
        tooltipFooterSpacer: isDisplayNone
            ? {
                  display: 'none',
              }
            : {},
        options: {
            arrowColor: colors.text.primary,
            backgroundColor: colors.text.primary,
            primaryColor: colors.primary,
            zIndex: 1300,
        },
        buttonNext: {
            color: colors.text.accent,
            fontSize: typography.size.desktop.paragraph.p3,
            lineHeight: `calc(${typography.lineHeight[2]} - 1px)`,
            padding: '6px 16px',
        },
        buttonClose: {
            color: colors.text.accent,
            fontSize: typography.size.desktop.paragraph.p3,
            lineHeight: `calc(${typography.lineHeight[2]} - 1px)`,
            padding: '6px 16px',
        },
        buttonSkip: {
            color: colors.text.tertiary,
            fontSize: 11,
            letterSpacing: '0.02em',
            lineHeight: `calc(${typography.lineHeight[1]} - 0.25px)`,
            padding: 0,
            textDecoration: 'underline',
        },
    };
    const joyrideConfig = {
        locale,
        steps,
        showSkipButton: true,
        disableCloseOnEsc: true,
        disableOverlayClose: true,
        hideCloseButton: true,
        hideBackButton: true,
        run: !showUserGuid,
        continuous: true,
        callback: handleJoyrideCallback,
        styles: { ...customStyles },
        scrollToFirstStep: false,
        disableScrollParentFix: true,
        disableScrolling: true,
    };

    return (
        <Joyride
            {...joyrideConfig}
            floaterProps={{
                style: {
                    left: 0,
                    height: 4,
                },
            }}
        />
    );
};

export { UserGuid };
